import style from '../invite.module.css';

const StaticEmail = ({ label, value, type, children }) => {
	const getValue = () => {
		if (type === 'date') {
			return new Date(value).toISOString().split('T')[0];
		}
		return value;
	};

	return (
		<div className={style.staticTextRowRoot}>
			<div className={style.staticTextRowLabel}>{label}</div>
			<div className={style.staticTextRowInput}>{children || getValue()}</div>
		</div>
	);
};

export default StaticEmail;
